<template>
  <a-spin :spinning="loading">
    <div class="delete-button" @click.stop="handleDelete">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.00305 20C5.00305 21.103 5.90005 22 7.00305 22H17.0031C18.1061 22 19.0031 21.103 19.0031 20V8H21.0031V6H18.0031H17.0031V4C17.0031 2.897 16.1061 2 15.0031 2H9.00305C7.90005 2 7.00305 2.897 7.00305 4V6H6.00305H3.00305V8H5.00305V20ZM9.00305 4H15.0031V6H9.00305V4ZM8.00305 8H16.0031H17.0031L17.0041 20H7.00305V8H8.00305Z"
          fill="#2D3346"
        />
        <path
          d="M9.00305 10H11.0031V18H9.00305V10ZM13.0031 10H15.0031V18H13.0031V10Z"
          fill="#2D3346"
        />
      </svg>
    </div>
  </a-spin>
</template>

<script setup>
  defineProps({
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits(['delete']);

  const handleDelete = () => emit('delete');
</script>

<style lang="scss" scoped>
  @use "@/assets/styles/_colors.scss" as *;

  .delete-button {
    padding: 0;
    background: transparent;
    border: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    cursor: pointer;

    &:hover {
      & > svg > path {
        fill: $color-btn-danger;
      }
    }
  }
</style>
